<template>
    <kgr-multi-select
        display="title"
        :value="selection"
        :options="clubFiles"
        :loading="loading"
        :disabled="disabled"
        searchable
        @post-input="updateSelection($event)"
    />
</template>

<script>
import ClubFileRepository from '../../../../js/repository/club/ClubFileRepository.js';
import MultiSelect from './MultiSelect.vue';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubFiles: [],
            selection: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('files');
        },
    },
    created() {
        this.load();
        this.selection = this.value;
    },
    methods: {
        load() {
            ClubFileRepository.findByClubId(this.clubId)
                .then((clubFiles) => this.clubFiles = clubFiles)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        updateSelection(value) {
            if (value.length === 0) {
                this.selection = [];
                this.$emit('input', []);
                this.$nextTick(() => {
                    this.$emit('post-input', []);
                });
            } else if (value.length > 0) {
                this.selection = value;
                this.$emit('input', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            }
        },
    },
};
</script>
